
export const Languages = [
    {lang: "EN", language: "English", flag: "united-kingdom.svg", locale: "en-GB"},
    {lang: "IT", language: "Italiano", flag: "italy.svg", locale: "it-IT"},
    {lang: "FR", language: "Français", flag: "france.svg", locale: "fr-FR"},
    {lang: "DE", language: "Deutsch", flag: "germany.svg", locale: "de-DE"},
    {lang: "ES", language: "Español", flag: "spain.svg", locale: "es-ES"}
];

